import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-1" }
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_4 = { class: "flex flex-col gap-1" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = { class: "flex flex-col gap-1" }
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col gap-1"
}
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_12 = { class: "flex flex-col gap-1" }
const _hoisted_13 = { class: "font-bold" }
const _hoisted_14 = {
  key: 1,
  class: "flex flex-col gap-1"
}
const _hoisted_15 = { class: "font-bold" }
const _hoisted_16 = { class: "flex items-center gap-2" }
const _hoisted_17 = {
  for: "receiveEmails",
  class: "cursor-pointer font-bold"
}
const _hoisted_18 = { class: "flex flex-col gap-2" }
const _hoisted_19 = { class: "font-bold" }
const _hoisted_20 = {
  key: 0,
  class: "flex justify-center py-3"
}
const _hoisted_21 = { class: "flex w-full justify-end gap-2" }

import { useUserFormValidation } from '@/composables/useUserFormValidation'
import { AuthUserType, UserRole, getUserRoleLabel, isAuthType } from '@/models/user'
import { useLanguageStore } from '@/stores/LanguageStore'
import { LoaderCircle } from 'lucide-vue-next'
import { Button, Checkbox, Dialog, Divider, InputText, MultiSelect, Select } from 'primevue'
import { computed, ref, watch } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserUpdateModal',
  props: {
    showModal: { type: Boolean },
    user: {},
    loading: { type: Boolean },
    isCurrentUserRoot: { type: Boolean },
    isSelfEdit: { type: Boolean },
    clientOptions: {},
    userClients: {},
    loadingClients: { type: Boolean }
  },
  emits: ["close", "save"],
  setup(__props: any, { emit: __emit }) {

const lang = useLanguageStore()
const { validName, validPassword, shouldValidatePassword } = useUserFormValidation()

const props = __props

const emit = __emit

const submitted = ref(false)
const isNormal = computed(() => !isAuthType(props.user?.userType, AuthUserType.LDAP))
const selectedClientIds = ref<string[]>([])

watch(
  () => props.userClients,
  (val) => {
    selectedClientIds.value = (val ?? []).map((c) => c.id)
  },
  { immediate: true },
)

const form = ref({
  name: props.user?.name ?? '',
  email: props.user?.email ?? '',
  password: '',
  confirmPassword: '',
  description: props.user?.description ?? '',
  userRole: props.user?.userRole ?? UserRole.User,
  receiveEmails: props.user?.receiveEmails ?? false,
})

const roleOptions = computed(() =>
  Object.values(UserRole)
    .filter(
      (v): v is UserRole =>
        Number.isInteger(v) &&
        v !== UserRole.Sap &&
        v !== UserRole.Erector &&
        (props.isCurrentUserRoot || v !== UserRole.Root),
    )
    .map((v) => ({ label: getUserRoleLabel(v), value: v })),
)

const selectedRole = computed({
  get: () => roleOptions.value.find((o) => o.value === form.value.userRole) ?? roleOptions.value[0],
  set: (val) => {
    if (val) form.value.userRole = val.value
  },
})

const visible = computed({
  get: () => props.showModal,
  set: (val: boolean) => {
    if (!val) emit('close')
  },
})

const originalClientIds = computed(() =>
  (props.userClients ?? []).map((c) => c.id).sort().join(','),
)
const currentClientIds = computed(() => [...selectedClientIds.value].sort().join(','))

const hasChanges = computed(() => {
  const clientChanges =
    props.clientOptions !== undefined && originalClientIds.value !== currentClientIds.value

  return (
    form.value.name !== (props.user?.name ?? '') ||
    form.value.description !== (props.user?.description ?? '') ||
    (!props.isSelfEdit && form.value.userRole !== (props.user?.userRole ?? UserRole.User)) ||
    form.value.receiveEmails !== (props.user?.receiveEmails ?? false) ||
    (isNormal.value && form.value.password !== '') ||
    clientChanges
  )
})

const submitForm = () => {
  submitted.value = true

  if (!validName(form.value.name)) return
  if (isNormal.value && shouldValidatePassword(form.value.password)) {
    if (!validPassword(form.value.password)) return
    if (form.value.password !== form.value.confirmPassword) return
  }

  emit('save', {
    ...form.value,
    id: props.user?.id,
    selectedClientIds: selectedClientIds.value,
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    maximizable: "",
    visible: visible.value,
    "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((visible).value = $event)),
    modal: "",
    header: _unref(lang).t('views.users.user'),
    class: "!w-[90vw] lg:!w-[40rem]"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_unref(Button), {
          label: _unref(lang).t('views.users.updateButton'),
          class: "w-48",
          onClick: submitForm,
          loading: __props.loading,
          disabled: __props.loading || !hasChanges.value
        }, {
          icon: _withCtx(() => [
            (__props.loading)
              ? (_openBlock(), _createBlock(_unref(LoaderCircle), {
                  key: 0,
                  class: "animate-spin"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["label", "loading", "disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _withModifiers(submitForm, ["prevent"]),
        class: "flex flex-col gap-4 text-sky-900 dark:text-slate-50"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("label", _hoisted_2, [
            _createTextVNode(_toDisplayString(_unref(lang).t('views.users.nameLabel')) + " ", 1),
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-red-500" }, "*", -1))
          ]),
          _createVNode(_unref(InputText), {
            modelValue: form.value.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
            class: _normalizeClass(["w-full", { 'p-invalid': submitted.value && !_unref(validName)(form.value.name) }])
          }, null, 8, ["modelValue", "class"]),
          (submitted.value && !_unref(validName)(form.value.name))
            ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(_unref(lang).t('views.users.nameMinLength')), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(lang).t('views.users.emailLabel')), 1),
          _createVNode(_unref(InputText), {
            modelValue: form.value.email,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.email) = $event)),
            disabled: "",
            class: "w-full opacity-60"
          }, null, 8, ["modelValue"])
        ]),
        (isNormal.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(lang).t('views.users.passwordLabel')), 1),
                _createVNode(_unref(InputText), {
                  type: "password",
                  modelValue: form.value.password,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.password) = $event)),
                  class: _normalizeClass(["w-full", {
              'p-invalid':
                submitted.value && _unref(shouldValidatePassword)(form.value.password) && !_unref(validPassword)(form.value.password),
            }]),
                  placeholder: _unref(lang).t('views.users.passwordOptionalPlaceholder')
                }, null, 8, ["modelValue", "placeholder", "class"]),
                (
              submitted.value && _unref(shouldValidatePassword)(form.value.password) && !_unref(validPassword)(form.value.password)
            )
                  ? (_openBlock(), _createElementBlock("small", _hoisted_8, _toDisplayString(_unref(lang).t('views.users.passwordRequirements')), 1))
                  : _createCommentVNode("", true)
              ]),
              (form.value.password)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("label", _hoisted_10, [
                      _createTextVNode(_toDisplayString(_unref(lang).t('views.users.confirmPasswordLabel')) + " ", 1),
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-red-500" }, "*", -1))
                    ]),
                    _createVNode(_unref(InputText), {
                      type: "password",
                      modelValue: form.value.confirmPassword,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.confirmPassword) = $event)),
                      class: _normalizeClass(["w-full", { 'p-invalid': submitted.value && form.value.password !== form.value.confirmPassword }])
                    }, null, 8, ["modelValue", "class"]),
                    (submitted.value && form.value.password !== form.value.confirmPassword)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(_unref(lang).t('views.users.passwordMismatch')), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(lang).t('views.users.descriptionLabel')), 1),
          _createVNode(_unref(InputText), {
            modelValue: form.value.description,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.description) = $event)),
            class: "w-full"
          }, null, 8, ["modelValue"])
        ]),
        (!__props.isSelfEdit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(lang).t('views.users.roleLabel')), 1),
              _createVNode(_unref(Select), {
                modelValue: selectedRole.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedRole).value = $event)),
                "option-label": "label",
                options: roleOptions.value,
                placeholder: _unref(lang).t('views.users.selectRolePlaceholder'),
                class: "w-full"
              }, null, 8, ["modelValue", "options", "placeholder"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_unref(Checkbox), {
            modelValue: form.value.receiveEmails,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.receiveEmails) = $event)),
            binary: "",
            "input-id": "receiveEmails"
          }, null, 8, ["modelValue"]),
          _createElementVNode("label", _hoisted_17, _toDisplayString(_unref(lang).t('views.users.receiveEmailsLabel')), 1)
        ])
      ], 32),
      (__props.clientOptions !== undefined)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_unref(Divider)),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(lang).t('views.users.clientLabel')), 1),
              (__props.loadingClients)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("i", { class: "pi pi-spin pi-spinner text-xl text-gray-400" }, null, -1)
                  ]))]))
                : (_openBlock(), _createBlock(_unref(MultiSelect), {
                    key: 1,
                    modelValue: selectedClientIds.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedClientIds).value = $event)),
                    options: __props.clientOptions,
                    "option-label": "fullName",
                    "option-value": "id",
                    placeholder: _unref(lang).t('views.users.noClientPlaceholder'),
                    display: "chip",
                    class: "w-full"
                  }, null, 8, ["modelValue", "options", "placeholder"]))
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}
}

})